<template>
  <b-modal
    :id="modalUniqueId"
    :modal-class="modalClasses"
    :hide-footer="true"
    ref="destroyPost"
    @hidden="hide"
  >
    <template v-slot:modal-title>
    </template>

    <template v-slot:default>
      <AlertWraper
        :content="errors"
        type="error"
      />
      <div class="text-center">
        <BaseIcon
          size="medium"
        >
          <WarningIcon />
        </BaseIcon>
        <h2 class="font-weight-bold font-size-medium text-color2">Atenção!</h2>
        <p>Você tem certeza que quer apagar a publicação <strong class="text-color2">{{ post ? post.title : '' }}</strong>?</p>
        <p>Essa ação é <strong class="text-color2">irreversível</strong>.</p>
        <div class="mt-4">
          <Button
              class="btn-primary btn-sm mr-2"
              :loading="loader"
              @click="submit"
            >
            Apagar
          </Button>
          <Button
            class="btn-outline-color2 btn-sm"
            @click="hide"
          >
            Cancelar
          </Button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>

import PostsService from '@/modules/posts/services/posts-service'
import NotificationService from '@/modules/notifications/services/notifications-service'
import { parseErrorResponseToArray } from '@/utils'
import { mapState } from 'vuex'

import AlertWraper from '@/components/common/Alert/AlertWraper.vue'
import BaseIcon from '@/components/common/Icon/BaseIcon.vue'
import Button from '@/components/common/Button/Button.vue'
import WarningIcon from '@/components/common/Icon/WarningIcon.vue'

export default {
  name: 'DestroyPostModal',
  props: ['post', 'type', 'id', 'modalId'],
  components: {
    AlertWraper,
    BaseIcon,
    Button,
    WarningIcon
  },
  data () {
    return {
      errors: null,
      loader: false
    }
  },
  computed: {
    ...mapState({
      nightMode: state => state.nightMode
    }),
    modalUniqueId () {
      if (this.modalId) {
        return this.modalId
      } else {
        return 'destroy-' + this.type + '-' + this.id
      }
    },
    isShowPage () {
      return this.$route.name === 'posts.show'
    },
    modalClasses () {
      return {
        'default-modal': true,
        'modal-small': true
      }
    }
  },
  methods: {
    async submit () {
      this.errors = null
      this.loader = true
      try {
        await PostsService.destroyPost(this.post.id)
        this.$bvModal.hide(this.modalUniqueId)
        const notification = {
          notification: {
            type: 'success',
            content: 'Publicação apagada com sucesso'
          }
        }
        NotificationService.createGlobalSuccessNotification(notification)
        this.$emit('post-destroyed')
        if (this.isShowPage) {
          this.$router.push(`/${this.post.user.username}`)
        }
      } catch (error) {
        this.errors = parseErrorResponseToArray(error)
      }
      this.loader = false
    },
    hide () {
      this.errors = null
      this.$bvModal.hide(this.modalUniqueId)
    }
  }
}
</script>
